import { getSiren } from '~/common/get-siren';
import { entityStore, sirenActions } from '~/utility/BinSentry-ui-utility';

const integrationSyncActionsConfig = [{
  integrationRel: 'https://api.binsentry.com/rel/microsoft-finance-and-operations-integration',
  actionName: 'sync-order',
  successMessage: 'sent to F&O',
}, {
  integrationRel: 'https://api.binsentry.com/rel/fas-integration',
  actionName: 'create-mobile-fas-order',
  successMessage: 'sent to FAS',
  // automatically send a new mobile order the first time - after that, the user can manually create a new one
  condition: fasIntegrationsEntity => !fasIntegrationsEntity?.properties.mobileEventReferenceNumbers?.length,
}];

export async function syncOrderIntegration(orderEntity) {
  const integrations = await getSiren(orderEntity.getLink('https://api.binsentry.com/rel/integrations'));
  const integrationsSyncActions = integrations ? await Promise.all(integrationSyncActionsConfig
    .map(async integrationAction => {
      const integration = await getSiren(integrations.getSubEntity(integrationAction.integrationRel), { bypassCache: true });
      const conditionMet = !integrationAction.condition || integrationAction.condition(integration);
      const syncAction = conditionMet && integration?.getAction(integrationAction.actionName);
      return syncAction && { syncAction, integration, successMessage: integrationAction.successMessage };
    }),
  ) : [];
  // Should have at most one orders integration.  If multiple, just use the first one.
  const actionOptions = integrationsSyncActions.find(Boolean);
  if (!actionOptions) {
    return { success: true };
  }
  const { syncAction, integration, successMessage } = actionOptions;
  try {
    await sirenActions.submitAction(syncAction);
    return { success: true, successMessage };
  } catch (error) {
    entityStore.invalidateHref(integration.getLink('self').href);
    return { success: false, error };
  }
}
